import styled from "@emotion/styled";
import { useOneLinkUrl } from "contexts/OneLinkScript";
import dynamic from "next/dynamic";

const QRCode = dynamic(() => import("qrcode.react"), {
    ssr: false, loading: () => <div
        style={{
            width: 90,
            height: 90,
            flexShrink: 0,
        }}
    />
});

const StyledQRWrapper = styled.div`
 width: 310px;
// height:  174px;
padding: 16px;
padding-left: 0px;
margin-left: -8px;
border-radius: 8px;
opacity: 0px;
display: flex;
align-items: center;
gap: 10px;
flex-direction: row;
  background: transparent;

`
const StyledText = styled.span`
font-size: 18px;
font-weight: 500;
line-height: 20px;
// text-align: center;
color:  #0068C9;
`

const QRCodeInHomePage = () => {

    const { oneLinkUrl } = useOneLinkUrl();
    return (
        <>
            <StyledQRWrapper>
                <QRCode
                    value={oneLinkUrl}
                    size={90}
                    bgColor="transparent"
                    fgColor="#0068C9"
                    level="M"
                    includeMargin={true}
                />
                <StyledText>
                    {"סרקו להורדת האפליקציה ותתחילו להטעין"}
                </StyledText>
            </StyledQRWrapper>
        </>
    )
}

export default QRCodeInHomePage;
